import styles from './ReportValue.module.less';
import { useTranslation } from 'react-i18next';

type Props = {
	testId: string;
	data: any;
	translationKey: string;
	dataType?: string;
};

export default function ReportValue(props: Props) {
	const { testId, data, translationKey, dataType = 'statistic' } = props;
	const { t } = useTranslation();
	return (
		// eslint-disable-next-line react/jsx-pascal-case
		<div>
			<div className={styles.reportValue} data-testid={testId}>
				{(data && t('common.' + dataType, { val: data })) || '--'}
			</div>
			<div className={styles.reportLabel} data-testid={`${testId}Label`}>
				{t(translationKey)}
			</div>
		</div>
	);
}
